"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const auth_1 = __importDefault(require("../auth"));
const Login = () => {
    const getDialogType = () => {
        const allowedDialogTypes = [
            constants_1.ScreenConstants.COMPLETE_REGISTER,
            constants_1.ScreenConstants.LOGIN_SCREEN,
        ];
        const dialogTypeParam = (0, helpers_1.getQueryStringValue)(constants_1.AuthenticateQueryStringConstants.DIALOGTYPE);
        const dialogType = allowedDialogTypes.includes(dialogTypeParam) ? dialogTypeParam : constants_1.ScreenConstants.LOGIN_SCREEN;
        return (dialogType);
    };
    (0, react_1.useEffect)(() => {
        login().then().catch((e) => {
            console.error('error while open slr popup in login page->', e.message);
        });
    }, []);
    const login = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const authInstance = auth_1.default.getInstance();
        const { country, language, platform, cityId } = authInstance;
        authInstance.screenType = getDialogType();
        const redirectUrl = (0, helpers_1.getQueryStringValue)(constants_1.AuthenticateQueryStringConstants.REDIRECT_URL);
        if (((_a = authInstance === null || authInstance === void 0 ? void 0 : authInstance.identity) === null || _a === void 0 ? void 0 : _a.id) && ((_b = authInstance === null || authInstance === void 0 ? void 0 : authInstance.identity) === null || _b === void 0 ? void 0 : _b.isNewUser) === false) {
            //redirect if the user try to back to authenticate page (full page) after login and the user is loggedIn and verified
            window.location.href = redirectUrl;
            return;
        }
        document.dispatchEvent(new CustomEvent(constants_1.OPEN_SSO_MODAL_EVENT, {
            detail: {
                country,
                platform,
                language,
                cityId,
                redirectUrl: redirectUrl
            },
        }));
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.default = Login;
